/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ArchiveRestoreIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="archive-restore"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.5 6.25C2.5 5.284 3.284 4.5 4.25 4.5L19.75 4.5C20.716 4.5 21.5 5.284 21.5 6.25C21.5 7.216 20.716 8 19.75 8L4.25 8C3.284 8 2.5 7.216 2.5 6.25Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 21L12 11M12 11L15.536 14.536M12 11L8.464 14.536" data-tinysvg-shape="arrow" data-tinysvg-arrow="12 21 12 11 50" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8 19.5L6 19.5C4.895 19.5 4 18.605 4 17.5L4 8L20 8L20 17.5C20 18.605 19.105 19.5 18 19.5L16 19.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
